import React, { useEffect, useState } from 'react'
import { Route, Redirect } from 'react-router-dom'
import * as R from 'ramda'

import FullRedirect from './FullRedirect'

// this is an array of regex's for routes that should not have hotjar
const noHotjar = [/\/survey\/.*?\/user/, /.*?\/user/, /.?\/passwordreset/]

const ProtectedRoute = ({ component: Component, title, ...rest }) => {
    const [loginChecked, setLoginChecked] = useState(false)
    const [newPath, setnewPath] = useState('')
    useEffect(() => {
        const checkLogin = async () => {
            await rest.store.checkLoggedInStatus(false)
            setLoginChecked(true)
            setnewPath(rest.path)
        }
        checkLogin()
    }, [rest.path])

    const { store: routeStore, isLoginChoose } = rest
    useEffect(() => {
        routeStore.isLoginChoose = R.isNil(isLoginChoose) ? false : isLoginChoose
    }, [routeStore, isLoginChoose])

    if (!loginChecked || rest.path !== newPath) return null

    return (
        <Route
            {...rest}
            render={(props) => {
                const {
                    store,
                    customRule,
                    roleRedirect,
                    location,
                } = rest
                const {
                    loggedIn,
                    tokenLoaded,
                    failedToLoadSurvey,
                    tokenData,
                    loginRedirect,
                } = store
                if (loggedIn && tokenLoaded && !failedToLoadSurvey) {
                    const currentRole = tokenData.roles.split(',')[0]
                    const redirectTo = rest.redirectFunc ? rest.redirectFunc(props) : R.pathOr('/', ['roleRedirect'], rest)
                    let canAccess = true

                    if (customRule && typeof customRule === 'function') {
                        canAccess = rest.customRule(roleRedirect, rest.role)
                    }

                    if (!canAccess) return <Redirect to={redirectTo} />
                    if (rest.role
                    && !rest.role.includes(currentRole)) return <Redirect to={redirectTo} />

                    document.title = title ? `explori.com - ${title}` : 'explori.com'

                    const hotJarBlocked = noHotjar.some((r) => r.test(location.pathname))

                    if (process.env.ENVIRONMENT !== 'dev' && !hotJarBlocked) {
                        store.hotJarSetup(props.location.pathname)
                    }

                    return (
                        <div className={hotJarBlocked ? 'data-hj-suppress' : ''}>
                            <Component {...props} {...rest} />
                        </div>

                    )
                }

                if (loginRedirect) {
                    if (location.pathname !== loginRedirect) {
                        return <Redirect to={loginRedirect} />
                    }

                    return <Component {...props} {...rest} />
                }

                if ((loggedIn && !tokenLoaded)
                || failedToLoadSurvey) return null

                return <FullRedirect to={`/login?pagePath=${props.location.pathname}`} />
            }}
        />
    )
}

export default ProtectedRoute
